<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriterionCreatorViewModel } from "@Criteria/Hierarchies/Components/CriterionCreator"

    // ---------------- props / emits ----------------

    const props = defineProps({
        viewModel: {
            type: Object as PropType<CriterionCreatorViewModel>,
            required: true
        }
    })

    const emit = defineEmits<{
        (e: 'create-criterion', parentId: number, name: string | null, description: string | null): void
    }>()

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const parentId = computed(() => vm.value.parentId)
    const parentName = computed(() => vm.value.parentName)

    // ---------------- actions ----------------

    function emitCreateCriterion()
    {
        vm.value.clearValidationErrors()
        emit("create-criterion", parentId.value!, vm.value.name, vm.value.description)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create under: {{parentName}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="criterion-creator-form" @submit.prevent="emitCreateCriterion">
                            <div class="form-group">
                                <label>Name <span style="color: red;">*</span></label>
                                <input v-model.trim="vm.name" type="text" class="form-control" required maxlength="100" minlength="2">
                                <div class="error">{{vm.nameError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                                <textarea v-model.trim="vm.description" class="form-control"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="criterion-creator-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>